import React from 'react';
import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EntityLinkProps {
	entityId: string;
	entityType: string;
	displayText: string;
	onEntityClick: (entityType: string, entityId: string) => void;
	className?: string;
}

export function EntityLink({
	entityId,
	entityType,
	displayText,
	onEntityClick,
	className
}: EntityLinkProps) {
	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		onEntityClick(entityType, entityId);
	};

	return (
		<button
			type="button"
			onClick={handleClick}
			className={cn(
				'inline-flex items-center gap-1.5 text-left text-blue-600 hover:opacity-70 transition-opacity',
				'focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:ring-offset-1 rounded-sm',
				'group cursor-pointer dark:text-blue-400',
				className
			)}
		>
			<span className="transition-all">
				{displayText}
			</span>
			<ExternalLink className="w-3 h-3 text-blue-600 dark:text-blue-400 flex-shrink-0" />
		</button>
	);
}
